var ValueJS = ValueJS || {};

ValueJS.BackToTop = function() {

    var _btn = $('.back-to-top');

    var _initialized = false;

    var _init = function() {
        if (!_initialized) {
            $(window).on('scroll', function() {
                _windowScroll();
            });
            _btn.on('click', function() {
                ValueJS.SmoothScroll.scroll($('#primaryNav'));
            })
            _initialized = true;
        }
    }

    var _windowScroll = function() {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            _btn.css('bottom', '20px');
        } else {
            _btn.css('bottom', '-40px');
        }
    }

    var _scrollToTop = function() {
        ValueJS.SmoothScroll.scroll($('#primaryNav'));
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
    };

}();

$(function() {
    // ValueJS.BackToTop.init();
});
